/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddrLine
 */
export interface AddrLine {
    /**
     * 
     * @type {string}
     * @memberof AddrLine
     */
    line?: string;
}

/**
 * Check if a given object implements the AddrLine interface.
 */
export function instanceOfAddrLine(value: object): value is AddrLine {
    return true;
}

export function AddrLineFromJSON(json: any): AddrLine {
    return AddrLineFromJSONTyped(json, false);
}

export function AddrLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddrLine {
    if (json == null) {
        return json;
    }
    return {
        
        'line': json['line'] == null ? undefined : json['line'],
    };
}

export function AddrLineToJSON(json: any): AddrLine {
    return AddrLineToJSONTyped(json, false);
}

export function AddrLineToJSONTyped(value?: AddrLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line': value['line'],
    };
}

